import type { IErrorPin } from '@/shared/common/types/pinError.type';

export const ErrorsPin: IErrorPin = {
  BAD_REQUEST: 'Ocurrió un error inesperado',
  FORBIDDEN: 'El pin actual no es correcto',
  PIN_REQUIRED: 'Se requiere pin de validación',
  PIN_FAILED_ATTEMPT_ONE: 'Pin inválido, intento fallido número 1',
  PIN_FAILED_ATTEMPT_TWO: 'Pin inválido, intento fallido número 2',
  PIN_FAILED_ATTEMPT_THREE: 'Pin inválido, intento fallido número 3',
  PIN_FAILED_ATTEMPT_FOUR: 'Pin inválido, intento fallido número 4',
  PIN_FAILED_ATTEMPT_FIVE: 'Pin inválido, intento fallido número 5',
  PIN_FAILED_ATTEMPT_SIX: 'Pin inválido, intento fallido número 6',
  ATTEMPT_LIMIT_EXCEEDED: 'Pin inválido, Límite de intentos superado. Debes cambiar tu Pin.',
  HELPER_COMPONENT: 'Token de acceso expirado',
  PIN_ALREADY_EXISTS: 'El usuario ya tiene un PIN registrado',
  UNAUTHORIZED: 'Token de acceso expirado',
  TRANSACTION_CUSTOMER_UNDER_COMPLIANCE_REVIEW_2:
    'Tu cuenta esta en revisión, comunícate con soporte (UCR2)',
  TRANSACTION_EXPIRED_QUOTE: 'La cotización ha expirado. Vuelve a generar uno nuevo',
  CUSTOMER_ACCOUNT_NEED_ATTENTION:
    'Tu cuenta necesita atención, contacta con un asesor',
  CUSTOMER_NOT_ENABLED: 'Tu cuenta no está habilitada para realizar esta operación',
  TRANSACTION_LIMIT_EXCEEDED:
    'El monto de la operación supera el límite permitido para tu cuenta',
  TRANSACTION_GENERIC_ERROR: 'Ocurrió un error inesperado, inténtalo más tarde',
  ERROR_EXCHANGE_SAME_CURRENCY:
    'No puedes realizar una operación con la misma moneda de origen y destino',
  GENERIC_ERROR: 'Ocurrió un error inesperado, inténtalo más tarde',
  CUSTOMER_NOT_FOUND: 'No se ha encontrado el usuario',
  TOO_MANY_REQUESTS: 'Has realizado muchas solicitudes, espera 5 minutos para volver a ingresar',
  UNSUPPORTED_TRANSFER_OPERATION: 'No es posible enviar dinero desde una billetera regulada a una billetera no regulada.',
} as const;
